import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type PropsWithChildren, type ReactNode, useState } from "react";

type Props = {
	title: string;
	icon?: ReactNode;
	expandable?: boolean;
	defaultExpanded?: boolean;
};

export const CollapsibleSection = ({
	title,
	icon,
	expandable = false,
	defaultExpanded = false,
	children,
}: PropsWithChildren<Props>) => {
	const theme = useTheme();
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);
	const showChildren = !expandable || isExpanded;

	return (
		<>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				px={1.6}
				py={1}
				onClick={expandable ? () => setIsExpanded(!isExpanded) : undefined}
				sx={expandable ? { cursor: "pointer" } : undefined}
			>
				<Stack direction="row" alignItems="center" gap="8px">
					{icon}
					<Typography
						variant="overline"
						color={theme.palette.deprecated.grey[500]}
					>
						{title}
					</Typography>
				</Stack>
				{expandable &&
					(isExpanded ? (
						<ChevronUp
							size={theme.iconSize.sm}
							color={theme.palette.deprecated.grey[400]}
						/>
					) : (
						<ChevronDown
							size={theme.iconSize.sm}
							color={theme.palette.deprecated.grey[400]}
						/>
					))}
			</Stack>
			{showChildren && children}
		</>
	);
};
